/** Справочник домена «Обращения». Был продублирован в обоих TicketChat. */

export const TICKET_STATUSES = ['open', 'in_progress', 'resolved', 'closed']

export const TICKET_STATUS_META = {
  open: { label: 'Открыт', tone: 'info' },
  in_progress: { label: 'В работе', tone: 'warning' },
  resolved: { label: 'Решён', tone: 'success' },
  closed: { label: 'Закрыт', tone: 'neutral' },
}

export const TICKET_PRIORITIES = ['low', 'normal', 'high', 'urgent']

export const TICKET_PRIORITY_META = {
  low: { label: 'Низкий', tone: 'success' },
  normal: { label: 'Обычный', tone: 'neutral' },
  high: { label: 'Высокий', tone: 'warning' },
  urgent: { label: 'Срочный', tone: 'danger' },
}

export const ticketStatusMeta = (s) => TICKET_STATUS_META[s] || TICKET_STATUS_META.open
export const ticketPriorityMeta = (p) => TICKET_PRIORITY_META[p] || TICKET_PRIORITY_META.normal

/** Закрытое обращение не принимает новые сообщения. */
export const isTicketClosed = (ticket) =>
  ticket?.status === 'closed' || ticket?.status === 'resolved'
